import { Box } from '@mui/material';
import { useListContext } from 'react-admin';
import { PredictionListCards } from './PredictionListCards';
import { StandardListCards } from './StandardListCards';
import { TapGridListCards } from './TapGridListCards';

export const ListCard = () => {
  const { filterValues } = useListContext();
  const { tradingType, depositType, withdrawType, ...baseFilter } = filterValues;

  const renderCards = () => {
    if (tradingType === 'Predict') {
      return (
        <PredictionListCards
          filter={baseFilter}
          depositType={depositType}
          withdrawType={withdrawType}
        />
      );
    }

    if (tradingType === 'TapGrid') {
      return <TapGridListCards filter={baseFilter} />;
    }

    return (
      <StandardListCards
        filter={baseFilter}
        tradingType={tradingType ?? 'Perp'}
        depositType={depositType}
        withdrawType={withdrawType}
      />
    );
  };

  return <Box>{renderCards()}</Box>;
};
